const SUPPORTED_LANGUAGES = ['fr', 'en'] as const;

const getLanguageCode = (language: string): (typeof SUPPORTED_LANGUAGES)[number] => {
  const languageCode = language?.substring(0, 2) as 'fr' | 'en';

  if (SUPPORTED_LANGUAGES.includes(languageCode)) {
    return languageCode;
  }

  const defaultLanguageCode = (process.env.REACT_APP_DEFAULT_LOCALE || 'en').substring(0, 2);

  return defaultLanguageCode as 'fr' | 'en';
};

/**
 * @component
 * @visibleName getLanguageCode
 */
export default getLanguageCode;
